import { Component, OnInit } from '@angular/core';
import {ContactDialogComponent} from '../../shared/components/dialogs';
import {MatDialog} from '@angular/material';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-mobile-landing',
  templateUrl: './mobile-landing.component.html',
  styleUrls: ['./mobile-landing.component.css', '../auth.component.css']
})
export class MobileLandingComponent implements OnInit {
  readonly SITE_URL = `${environment.SITE_URL}/`;

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  openDialog() {
    const dialogRef = this.dialog.open(ContactDialogComponent, {
      panelClass: 'contact-dialog',
      data: {
        context: 'login page',
      }
    });
  }

}
